// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"9f686683","400":"6fa0236e","453":"5977fe42"}[chunkId] + ".chunk.js";
};